import type { CalculationLogEntry, ReasonCode, SnapshotDiffRow } from '../types'

export interface CoachAdjustmentLogDto {
  id: string
  coachUserId: string | null
  coachName: string
  targetTable: string
  field: string
  reasonCode: ReasonCode
  reason: string | null
  kind: 'original' | 'replay'
  occurredAt: Date | string
  valueBefore?: unknown
  valueAfter?: unknown
  summary?: string
  rationale?: string
  snapshotDiff?: SnapshotDiffRow[]
  graphJsonReasonMetadata?: {
    role: 'origin' | 'propagated'
    originClientId?: string
    originCoachUserId?: string | null
    originCoachName?: string
    originAdjustmentId?: string
  } | null
}

export function mapCoachAdjustmentToCalcLogEntry(
  row: CoachAdjustmentLogDto,
): CalculationLogEntry {
  const occurredAt =
    row.occurredAt instanceof Date
      ? row.occurredAt.toISOString()
      : row.occurredAt

  return {
    id: row.id,
    occurredAt,
    source: 'coach_adjustment',
    kind: row.kind,
    replacesEntryIds: [],
    sourceTable: 'CoachAdjustmentLog',
    sourceRowId: `CoachAdjustmentLog:${row.id}`,
    actorKind: 'coach',
    actorName: row.coachName,
    reasonCode: row.reasonCode,
    rationale:
      row.rationale ??
      (row.reasonCode === 'graph_json_saved'
        ? 'Global graph structure or coordinates changed.'
        : (row.reason ?? 'Coach adjustment recorded.')),
    summary:
      row.summary ??
      (row.reasonCode === 'graph_json_saved'
        ? 'Graph JSON editor state saved.'
        : `${row.field} updated`),
    rowsAffected: [],
    snapshotDiff: row.snapshotDiff,
    graphJsonReasonMetadata: row.graphJsonReasonMetadata ?? undefined,
    valueBefore: row.valueBefore,
    valueAfter: row.valueAfter,
    coachUserId: row.coachUserId,
  }
}

export function mapCoachAdjustmentsToCalcLogEntries(
  rows: CoachAdjustmentLogDto[],
): CalculationLogEntry[] {
  return rows.map(mapCoachAdjustmentToCalcLogEntry)
}
